A response to a component in a questionnaire.

This only contains metadata related to the component responded to in the questionnaire.
The implementation of a response is based on the `componentTypeCode` of its component.
